import React from "react";
import { Typography } from "antd";
import { usePublishPageCrumb } from "../../../data/hooks/usePageCrumb";

const { Title } = Typography;

/**
 * Paginakop: titel, een regel met kerncijfers/context eronder, acties rechts.
 *
 * Vervangt de losse `<h2>` die de inkooppagina's nu gebruiken. De subtitel is
 * bedoeld voor "73 orders · 11 actief · 1 wacht op goedkeuring": de gebruiker
 * ziet meteen waar de aandacht heen moet zonder de tabel te hoeven scannen.
 *
 * Publiceert daarnaast zijn titel als laatste breadcrumb in de layout-header.
 * Zo hoeft geen enkele pagina zelf een kruimel te zetten: op een detailpagina is
 * `title` al het recordnummer. Met `crumbLabel` kan een pagina daarvan afwijken
 * (bijv. het factuurnummer zonder de "Factuur"-fallback), en met
 * `crumbLabel={null}` publiceert hij niets.
 */
const PageHeader = ({ title, subtitle, extra, meta, crumbLabel, style }) => {
  usePublishPageCrumb(crumbLabel !== undefined ? crumbLabel : typeof title === "string" ? title : null);

  return (
    <div
      style={{
        display: "flex",
        alignItems: meta ? "flex-start" : "flex-end",
        justifyContent: "space-between",
        gap: 20,
        flexWrap: "wrap",
        marginBottom: 20,
        ...style,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: meta ? 8 : 3, minWidth: 0 }}>
        <Title level={2} style={{ margin: 0, fontSize: 26, fontWeight: 500, letterSpacing: "-0.02em" }}>
          {title}
        </Title>
        {subtitle ? <span style={{ fontSize: 13, color: "rgba(0, 0, 0, 0.55)" }}>{subtitle}</span> : null}
        {meta ? (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "4px 14px",
              alignItems: "center",
              fontSize: 13,
              color: "rgba(0, 0, 0, 0.55)",
            }}
          >
            {meta}
          </div>
        ) : null}
      </div>
      {extra ? <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>{extra}</div> : null}
    </div>
  );
};

export default PageHeader;
